import { useCallback } from "react";
import { handleScrollToItem } from "../../../../../app_shared_functions";

const useDuplicateClickErrorHandler = ({
  error,
  showFormWarning,
}: {
  error: any;
  showFormWarning: () => void;
}) => {
  return useCallback(() => {
    showFormWarning();
    if (error) {
      handleScrollToItem(error.ref);
    }
  }, [showFormWarning, error]);
};

export default useDuplicateClickErrorHandler;
